/*
 * v-safe-html — Vue 2 directive that renders sanitised HTML.
 * Drops <script>, event handlers, javascript: URIs, and other XSS vectors
 * via DOMPurify. See src/lib/sanitiseHtml.js for the allowlist.
 *
 * Use exactly like v-html:
 *   <span v-safe-html="userContent" />
 */
import { sanitiseHtml } from '@/lib/sanitiseHtml'

function setSafeHtml (el, binding) {
  el.innerHTML = sanitiseHtml(binding.value)
  // What this directive wrote, so unbind can tell it from content Vue wrote afterwards.
  el.__safeHtml = el.innerHTML
}

// Like Vue's own v-html, which is a domProp that Vue resets when the element is reused: when the
// directive is removed from an element that stays (a same-tag v-if / v-else with no key), clear
// what it wrote, or the HTML stays and the new content is appended beneath it. Only when the
// element still holds what it wrote: a reused sibling with v-text / v-html has had its own
// content written by Vue BEFORE this runs, and that must stay. On a destroy Vue
// removes the element itself, and clearing it first would only empty it before a leave transition.
function clearSafeHtml (el, binding, vnode, oldVnode, isDestroy) {
  if (!isDestroy && el.innerHTML === el.__safeHtml) {
    el.innerHTML = ''
  }
}

export default {
  bind: setSafeHtml,
  update: setSafeHtml,
  unbind: clearSafeHtml
}
